<script lang="ts">
    import {Flex} from 'shared/layouts';
    import type {GridField} from 'src/features/record-grid/lib/types';
    import {getTextFromGridFieldValue} from 'src/features/erp-sutor/sutor-utils';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let machineField: GridField;
</script>

<Flex>
    <GridFieldValue field={machineField}>
        <div class="icon-container">
            <UIcon icon="gears"/>
        </div>

        <span class="machine-name">
            {getTextFromGridFieldValue(machineField)}
        </span>
    </GridFieldValue>
</Flex>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .icon-container {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid @themed-border-default;
        background-color: @themed-body-bg-orange-highlighted;
        font-size: @font-size-large;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--brand-orange);
    }

    .machine-name {
        font-size: @font-size-xl;
    }
</style>